import { put } from '../..';

const updateFloorOrder = (Order: { LocationId: string, Index: number }[]) => put(
  'locations/floors/order',
  { Order },
);

export default updateFloorOrder;
